// Note: cache only available to the client (prevents unbounded growth during SSR)
const AreaBoundaryCache = typeof window !== 'undefined' ? new Map() : undefined;

interface GeoJson {
  id: number;
}

const cacheActions = {
  add(geoJson: GeoJson = {} as GeoJson) {
    const { id: areaId } = geoJson;

    if (!AreaBoundaryCache?.get(areaId)) {
      AreaBoundaryCache?.set(areaId, geoJson);
    }
  },

  get(areaId: number) {
    return AreaBoundaryCache?.get(areaId);
  },

  size() {
    return AreaBoundaryCache?.size ?? 0;
  },
};

export default cacheActions;
